import * as angular from "angular";

angular
  .module('app.permission', [
    'permission', 'permission.ui'
  ]);
